import * as React from 'react';
import { useState } from 'react';
import { Container, Paper, Typography } from '@mui/material';
import { useSelector } from '../../store/store';
import Log from '../../lib/log';
import { formatNumber } from '../../functions/Utils';

// ログの初期化
const log = new Log('LectureTestCall');

export default function LectureTestCall() {
  log.putLog('info', 'LectureTestCall started.');
  const [setupUser] = useState(useSelector((state) => state.setupUser));

  // const formatNumber = (number: string) => {
  //   return `${number.substring(0, 3)}-${number.substring(
  //     3,
  //     7,
  //   )}-${number.substring(7)}`;
  // };

  return (
    <Paper
      sx={{
        p: 2,
        display: 'flex',
        flexDirection: 'column',
        height: 'auto',
      }}
    >
      <Typography variant='h6' gutterBottom component='div' color={'gray'}>
        まずは動作の確認をしましょう
      </Typography>
      <Typography sx={{ mt: 2, mb: 1 }} color='primary'>
        Step 1
      </Typography>
      <Typography component='p' color={'black'}>
        {setupUser.nickname}
        さんに割り当てられた以下の電話番号に電話をして、応答メッセージが流れることを確認します。
      </Typography>
      <Typography variant='h6' gutterBottom component='div' color={'blue'}>
        {formatNumber(setupUser.serviceNumber)}
      </Typography>
      <Typography sx={{ mt: 2, mb: 1 }} color='primary'>
        Step 2
      </Typography>
      <Typography component='p' color={'black'}>
        何かメッセージを吹き込み電話を切ります。
      </Typography>
      <Typography sx={{ mt: 2, mb: 1 }} color='primary'>
        Step 3
      </Typography>
      <Typography component='p' color={'black'}>
        {setupUser.email}宛に、音声認識結果が通知されることを確認します。
      </Typography>
      <Typography sx={{ mt: 3 }} color='red'>
        メールが届かない場合は...
      </Typography>
      <Typography component='ol' color={'black'}>
        <li>メールアドレス「{setupUser.email}」が間違っていませんか？</li>
        <li>
          送信元ドメイン「transrec.net」からのメールを受信できるようになっていますか？
        </li>
      </Typography>

      <Container component='main' maxWidth='xs'></Container>
    </Paper>
  );
}
